import axios from "axios";
import queryString from "query-string";
import { INVOICING } from "../state/actions/orderActions";
import config from "../config";

const mapAdditionalFields = fieldsObject => {
  return Object.keys(fieldsObject)
    .map((key, index) => {
      const value = fieldsObject[key];
      return {
        questionId: key,
        value: value
      };
    })
    .filter(q => q.value !== null);
};

const OrderService = {
  get(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config("API_URL")}order/${id}`)
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  addDiscount(eventId, orderId, discountCode) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config("API_URL")}discounts/add`, {
          eventId,
          orderId,
          discountCode
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  async getPublicOrder(eventId, orderId, token) {
    const response = await axios.get(
      `${config(
        "API_URL"
      )}public/edit-order/order/${orderId}/${eventId}/${token}`
    );
    return response.data;
  },
  async savePublicOrder(eventId, orderId, token, orderData) {
    const response = await axios.post(
      `
    ${config("API_URL")}public/edit-order/order/${orderId}/${eventId}/${token}`,
      orderData
    );
    return response.data;
  },
  async addGiftCard(eventId, orderId, giftCardCode) {
    const response = await axios.post(`${config("API_URL")}gift-cards/add`, {
      eventId,
      orderId,
      giftCardCode
    });
    return response.data;
  },

  async completeOrderWithGiftCard(orderId) {
    const response = await axios.post(
      `${config("API_URL")}gift-cards/complete`,
      {
        orderId
      }
    );
    return response.data;
  },

  async removeGiftCard(orderId) {
    const response = await axios.post(`${config("API_URL")}gift-cards/remove`, {
      orderId
    });
    return response.data;
  },
  removeDiscount(orderId) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config("API_URL")}discounts/remove`, {
          orderId
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  summary(
    id,
    requestedTickets,
    clientDonation,
    order,
    merch,
    giftCard,
    isEventId
  ) {
    const tickets = order && order.tickets ? order.tickets : requestedTickets;
    const isInvoice = order && order.paymentMethod === INVOICING;
    const orderId = order && order._id ? order._id : false;
    let isManualOrder = false;
    if (window) {
      isManualOrder =
        window.manualOrderToken &&
        window.isManualOrder &&
        window.manualOrderSettings;
    }
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config("API_URL")}order${!isEventId ? "/global" : ""}/summary`,
          {
            [isEventId ? "eventId" : "userId"]: id,
            tickets: tickets ? tickets : [],
            merch: merch ? merch : [],
            giftCard: giftCard ? giftCard : [],
            clientDonation,
            isInvoice,
            orderId,
            isManualOrder
          }
        )
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  request(
    id,
    eventDateId,
    requestedItems,
    discountCode,
    clientDonation,
    lastOrderId,
    isGlobal,
    manualOrderValues
  ) {
    const isBrowser = typeof window !== "undefined";
    let offerId;
    if (isBrowser) {
      const parsed = queryString.parse(window.location.search);
      // get the offer id for waitlist clients
      offerId = parsed.offerid;
    }
    return new Promise((resolve, reject) => {
      axios
        .put(
          `${config("API_URL")}order${isGlobal ? "/global" : ""}/request`,
          {
            [!isGlobal ? "eventId" : "userId"]: id,
            eventDateId,
            [!isGlobal
              ? "requestedTickets"
              : "requestedGiftCards"]: requestedItems,
            discountCode,
            clientDonation,
            lastOrderId,
            offerId
          },
          { params: manualOrderValues }
        )
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  saveDetails(orderData, tickets, ticketsData, hasAdditionalSteps, isGlobal) {
    orderData.additionalFields = orderData.additionalFields
      ? mapAdditionalFields(orderData.additionalFields)
      : orderData.additionalFields;
    // merge ticket additional fields
    const ticketLookUp = {};
    tickets.forEach((ticket, index) => {
      ticketLookUp[ticket._id] = index;
    });
    if (isGlobal) {
      ticketsData.forEach(giftCard => {
        const index = ticketLookUp[giftCard.giftCardId];
        let giftCardLookup = tickets[index];
        if (giftCardLookup) {
          tickets[index] = { ...giftCardLookup, ...giftCard };
        }
      });
    } else if (ticketsData) {
      Object.keys(ticketsData).map((key, index) => {
        let ticket = tickets[ticketLookUp[key]];
        if (ticket) {
          ticket.additionalFields = mapAdditionalFields(ticketsData[key]);
        }
      });
    }
    return new Promise((resolve, reject) => {
      axios
        .post(`${config("API_URL")}order/${isGlobal ? "global/" : ""}details`, {
          orderData,
          [isGlobal ? "giftCardData" : "ticketData"]: tickets,
          hasAdditionalSteps: hasAdditionalSteps
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  saveAfterCheckoutQuestions(eventId, orderData, tickets, ticketsData) {
    orderData.additionalFields = orderData.additionalFields
      ? mapAdditionalFields(orderData.additionalFields)
      : orderData.additionalFields;
    const ticketLookUp = {};
    tickets.forEach((ticket, index) => {
      ticketLookUp[ticket._id] = index;
    });
    if (ticketsData) {
      Object.keys(ticketsData).map((key, index) => {
        let ticket = tickets[ticketLookUp[key]];
        if (ticket) {
          ticket.additionalFields = mapAdditionalFields(ticketsData[key]);
        }
      });
    }
    return new Promise((resolve, reject) => {
      axios
        .post(`${config("API_URL")}order/afterCheckout`, {
          eventId,
          orderData,
          ticketData: tickets
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  pay(orderId, gateway, details, eventId, isGlobal) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config("API_URL")}order/pay`, {
          orderId,
          gateway,
          details,
          eventId,
          isGlobal
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};
export default OrderService;
